import {ServiceBase} from '../ServiceBase';
import {IOverlayService} from './overlay.service.interface';
import { action, computed, observable, runInAction, makeObservable } from 'mobx';
import {IServiceFactoryExtended} from '../service-factory-extended.interface';
import {IOverlayConsumer, IOverlaySubscription} from "./overlay-consumer.interface";
//import {LoginFormOverlayController} from "./login-form-overlay-controller";
import {Check} from "@sparkware/app-utils";


export class OverlayService extends ServiceBase implements IOverlayService {

  constructor(services: IServiceFactoryExtended) {
    super(services);

    makeObservable(this);

    //this._loginFormOverlayController = new LoginFormOverlayController(services);
    //this.registerConsumer(this._loginFormOverlayController);
    this.reaction(
      () => this.isOpen,
      (isOpen) => {
        if(isOpen) {
          this.disableScrolling();
        } else {
          this.enableScrolling();
        }
      }
    );
  }

  //private readonly _loginFormOverlayController: LoginFormOverlayController;

  @observable
  private _overlayConsumers: IOverlayConsumer[] = [];

  registerConsumer(consumer: IOverlayConsumer): IOverlaySubscription {
    runInAction(() => {
      this._overlayConsumers.push(consumer);
    });

    return {
      unsubscribe: () => {
        const index = this._overlayConsumers.findIndex(c => c === consumer);
        if(index >= 0) {
          runInAction(() => {
            this._overlayConsumers.splice(index, 1);
          })
        }
      }
    }
  }


  get zIndex(): number | undefined {
    const zIndexes = this._overlayConsumers.filter(c => c.needsOverlay)
                                           .map(c => c.getOverlayZIndex())
                                           .filter(zIndex => !Check.isNullOrUndefined(zIndex));
    if(zIndexes.length === 0) {
      return undefined;
    }

    return Math.max(...zIndexes);
  }

  countCurrentConsumers(predicate: (consumer: IOverlayConsumer) => boolean): number {
    let count = 0;
    for(let c of this._overlayConsumers) {
      if(predicate(c)) {
        count++;
      }
    }
    return count;
  }


  @computed
  get isOpen(): boolean {
    //We do map here to iterate over all consumer in this way isOpen will be dependent on all observables in the _overlayConsumers
    return this._overlayConsumers.map(c => c.needsOverlay)
                                 .some(needsOverlay => needsOverlay);
  }


  @action.bound
  closeOverlay(): void {
    this._overlayConsumers.forEach(c => c.onOverlayClicked());
  }

  disableScrolling(): void {
    this.services.dom.disableScrolling();

  }
  enableScrolling(): void {
    if(!this.isOpen) {
      this.services.dom.enableScrolling();
    }

  }
}
